/**
 * @fileOverview This file defines the RegionsPage component, which renders the regions table.
 * @version 1.0.0
 * @since 1.0.0
 * @author Santiago Cano
 */

import { Helmet } from 'react-helmet'; // Helmet for setting page metadata in the head
import { RegionsTable } from '../../components/Tables/Sigma/RegionsTable'; // Table component to display regions

/**
 * Renders the RegionsPage component, which includes the regions table and page metadata.
 * @returns {JSX.Element} The RegionsPage component.
 */
const RegionsPage = () => {
  return (
    <div className='table-module-container'>
      {/* Helmet sets the HTML <title> dynamically */}
      <Helmet>
        <title>Regions</title>
      </Helmet>
      <div className='datatable'>
        {/* Render the RegionsTable component */}
        <RegionsTable />
      </div>
    </div>
  );
};

export default RegionsPage;
